import noop from 'lodash/noop';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { ReferencedEntry } from 'contentful';
import { SalesChannelContext, useSalesChannelInternal } from './UseSalesChannel';

const initialContext: SalesChannelContext = {
  setTrackingHost: noop,
  salesChannel: undefined,
  trackingHost: undefined,
  rateSchedule: [],
  planSchedule: [],
  isDisallowedByReseller: (entry?: ReferencedEntry<any>) => false,
};

const SalesChannel = React.createContext<SalesChannelContext>(initialContext);
SalesChannel.displayName = 'SalesChannel';

export const useSalesChannel = () => useContext(SalesChannel);

export const SalesChannelProvider: React.FC = ({ children }) => {
  const { i18n } = useTranslation();
  return (
    <SalesChannel.Provider value={useSalesChannelInternal(i18n.language)}>
      {children}
    </SalesChannel.Provider>
  );
};

export const SalesChannelConsumer = SalesChannel.Consumer;
